import React from 'react';
import { MapPin } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-61">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/oRwzHKHrj6c4gq6tXGyuUW/Screenshot_2026-02-19_at_11.47.39_AM.png')"
    }} data-id="element-62">
        {/* Subtle gradient only at very bottom for auction bar readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" data-id="element-63" />
      </div>

      {/* Content Container */}
      <div className="relative h-full w-full max-w-7xl mx-auto px-6 flex flex-col justify-between py-12" data-id="element-64">
        {/* Top Bar — minimal, just the Stonebridge logo */}
        <div className="flex justify-start" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/bFck38gvxuhrFv3WeugoiY/Stonebridge_logo_master_reversed_1.0.png" alt="Stonebridge Property Group" className="h-8 md:h-10 object-contain" data-id="element-66" />
        </div>

        {/* Main Title Block - Added for clarity and impact */}
        <div className="flex-1 flex flex-col justify-center items-start max-w-4xl" data-id="element-67">
          <h1 className="text-white text-5xl md:text-7xl font-bold tracking-tight leading-tight mb-4 drop-shadow-lg" data-id="element-68">
            401 Chapel Street
          </h1>
          <p className="text-white/90 text-2xl md:text-3xl font-light tracking-wide uppercase drop-shadow-md" data-id="element-69">
            South Yarra
          </p>
          <div className="w-24 h-1 bg-[#87C4D8] mt-8" data-id="element-70" />
        </div>

        {/* Bottom Bar / Auction Details */}
        <div className="bg-black/40 backdrop-blur-md border-t border-white/20 p-6 md:p-8" data-id="element-71">
          <div className="flex flex-col md:flex-row justify-between items-end gap-4" data-id="element-72">
            <div data-id="element-73">
              <p className="text-white/60 text-xs uppercase tracking-widest mb-1" data-id="element-74">
                For Sale via Public On-Site Auction
              </p>
              <p className="text-white text-xl md:text-2xl font-bold" data-id="element-75">
                Friday 27th March 2026 at 12:30pm (AEDT)
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-76" />
            <div className="text-right md:text-left" data-id="element-77">
              <p className="text-white/60 text-xs uppercase tracking-widest mb-1" data-id="element-78">
                On-Site
              </p>
              <p className="text-white text-lg font-medium" data-id="element-79">
                401 Chapel Street, South Yarra
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}